import { ExprValue } from '../ExprValue';
import { validateArguments } from '../../SignatureValidation';
export var LookupFn;
(function (LookupFn) {
    LookupFn.Name = `LOOKUP`;
    LookupFn.Stage = "ANALYTIC";
    LookupFn.Signature = `LOOKUP(<expression>, [<offset>])`;
    function make(callName, args, type, role) {
        return {
            name: LookupFn.Name,
            stage: LookupFn.Stage,
            data: { type, role },
            value: (context, ...argVals) => {
                return value(context, argVals[0], argVals[1]);
            },
        };
    }
    LookupFn.make = make;
    function value(context, values, offsets) {
        const { state, frame: { index }, } = context;
        let offset = 0;
        if (offsets !== undefined) {
            offset = offsets[index];
        }
        let value = null;
        if (typeof offset === 'number') {
            value = values[index + offset];
        }
        else if (ExprValue.isDecimal(offset)) {
            value = values[index + offset.toNumber()];
        }
        return {
            value: value !== null && value !== void 0 ? value : null,
            state,
        };
    }
    LookupFn.value = value;
    function validate(callNode, callName, args) {
        const arity = args.length;
        const sig = {
            meta: {
                name: LookupFn.Name,
                signature: LookupFn.Signature,
                location: callNode.location,
            },
            arguments: arity === 1
                ? [
                    {
                        stages: [
                            "ANALYTIC",
                            "AGGREGATE",
                            "CONST",
                        ],
                    },
                ]
                : [
                    {
                        stages: [
                            "ANALYTIC",
                            "AGGREGATE",
                            "CONST",
                        ],
                    },
                    {
                        type: "NUMERIC",
                        stages: [
                            "ANALYTIC",
                            "AGGREGATE",
                            "CONST",
                        ],
                    },
                ],
        };
        return validateArguments(sig, args);
    }
    LookupFn.validate = validate;
})(LookupFn || (LookupFn = {}));
